import * as types from "./types";

const mutations = {
    [types.LOADING_ALLOCATION](state, value) {
        state.loading = value;
    },
    [types.GET_ALLOCATION_LIST](state, allocation) {
        state.allocation = allocation;
    },
    [types.GET_ALLOCATION_ID](state, id) {
        state.id = id;
    },
    [types.REMOVE_ALLOCATION](state, id) {        
        state.allocation = state.allocation.filter((x) => x.id !== id);        
    },
    [types.ADD_ALLOCATION](state, allocation) {        
        state.allocation.unshift(allocation);
    },
    [types.UPDATE_ALLOCATION](state, allocation) {        
        const allocationIndex = state.allocation.findIndex((x) => x.id === allocation.id);
        state.allocation[allocationIndex] = allocation;        
    },
    [types.ADD_PAYROLL](state, payroll) {        
        state.payroll.unshift(payroll);
    },
    [types.GET_PAYROLL_LIST](state, payroll) {
        state.payroll = payroll;
    },
    [types.GET_EMPLOYEE_PAYROLL](state, u_id) {
        state.u_id = u_id;
    },
    [types.IMPORT_ALLOCATION](state, allocation) {
        state.allocation = allocation;
    },
};

export default mutations;